import type { WritableSignal } from '@angular/core';
import type { Observable } from 'rxjs';
import { catchError, map, of } from 'rxjs';

/**
 * Padrão repetido dos fetches Apollo `no-cache` desta feature: liga `loadingSignal`, assina
 * `fetch$`, projeta o resultado com `pick`, cai para `fallback` em erro (falha sempre silenciosa —
 * não bloqueia a UI), escreve em `targetSignal` e desliga `loadingSignal` ao concluir.
 */
export function loadInto<TResult, TValue>(
  loadingSignal: WritableSignal<boolean>,
  targetSignal: WritableSignal<TValue>,
  fetch$: Observable<TResult>,
  pick: (result: TResult) => TValue,
  fallback: TValue,
): void {
  loadingSignal.set(true);
  fetch$
    .pipe(
      map(pick),
      catchError(() => of(fallback)),
    )
    .subscribe((value) => {
      targetSignal.set(value);
      loadingSignal.set(false);
    });
}
